<template>
  <div class="pano-viewer" id="id" style="display: none; width: 100%; height: 100%;">
      <div class="krpano-overlay" :class="{ hidden: !showIndex }">
          <a class="krpano-index-toggle" v-on:click.prevent="toggleIndex()" href="#"></a>
          <responsive-image v-if="logo" class="pano-logo" img-class="img-responsive"
            :src="logo">
          </responsive-image>
          <h2 v-if="title">{{ title }}</h2>
          <div v-if="debug" class="alert alert-warning">
            Aktive Szene: {{ activeScene }}
          </div>
          <div class="krpano-index" v-if="scenes">
            <div v-for="category in scenes">
              <a v-if="category.handle" class="pano-switch" v-on:click="changeScene(category.handle)" :class="{ active: (category.handle === activeScene) }" href="JavaScript:void(0)">{{ category.title }}</a>
              <span v-else-if="category.title" class="pano-switch" href="JavaScript:void(0)">{{ category.title }}</span>
              <ul v-if="category.scenes">
                <li v-for="scene in category.scenes">
                  <a class="pano-switch" v-on:click="changeScene(scene.handle)" :class="{ active: (scene.handle === activeScene) }" :data-pano-item="scene.handle" href="JavaScript:void(0)">{{ scene.title }}
                    <span v-if="debug">handle: {{scene.handle }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
      </div>
      <krpano v-if="showPano" :xml="xml" :lazy-load="lazyLoad" style="width:100%;height:100%;"
              :scene="activeScene"
              :debug="debug"
              :hooks="hooks"
              :consolelog="debug"
              v-on:panoCreated="panoCreated"
              :initvars="{hotspot_dir: hotspot_dir, pano_image_dir: pano_image_dir}">
      </krpano>
  </div>
</template>
<style></style>
<script type="module">
export default {
  name: "pano-viewer",
  props: {
    title: '',
    lazyLoad: true,
    logo: '',
    showPano: true,
    panoOpacity: 0,
    startingScene: '',
    scenes: [],
    xml: '',
    hotspot_dir: '',
    pano_image_dir: '',
    debug: false
  },
  data: function () {
    const self = this;
    return {
      activeScene: '',
      id: '',
      showIndex: true,
      hooks: {
        switchScene( scene ) {
          self.changeScene(scene);
        }
      }
    }
  },
  computed: {},
  methods: {
    changeScene: function( scene ){
      if(this.debug)console.log('change szene: '+scene);
      this.activeScene = scene;
      this.showIndex = true;
    },
    toggleIndex: function() {
      this.showIndex = ! this.showIndex;
    },
    panoCreated: function( pano ) {
      if(this.debug)console.log('startup! ');
      if(this.debug)console.log( pano.id );
      setTimeout(()=> this.showIndex = false,3500);
    }
  },
  activated() {

  },
  created() {
    if(!this.id){
      this.id = this._uid;
    }
    if(this.startingScene){
      this.activeScene = this.startingScene;
    }else if(this.scenes[0].startingScene){
        this.activeScene = this.scenes[0].startingScene;
    }
  },
  updated() {

  }
}
</script>
